export default {
  zh: {
    unsubscribe_title: '退订以后不再接收邮件内容，确定要退订吗？',
    unsubscribe_button: '取消订阅',
    resubscribe_title: '已退订，将不再接收此邮件内容。',
    resubscribe_button: '恢复订阅',
    restored_title: '已恢复订阅，您将继续接收此邮件'
  },
  en: {
    unsubscribe_title: 'You will not receive message from this email after unsubscription. Do you really want to unsubscribe?',
    unsubscribe_button: 'Unsubscribe',
    resubscribe_title: 'You have successfully unsubscribed, and you will no longer receive our emails.',
    resubscribe_button: 'Resubscribe',
    restored_title: 'Your subscription has been restored and you will continue to receive our emails.'
  }
}



// WEBPACK FOOTER //
// ./src/views/subscribeManage/lang.js